
import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { animalMapping, getGroupFromNumber, getAnimalInfo } from "@/utils/animalImages";

type PredictionDetailsCardProps = {
  open: boolean;
  onClose: () => void;
  prediction: string;
  predictionType: "milhar" | "centena" | "grupo" | "duque" | "terno";
};

const PredictionDetailsCard = ({ 
  open, 
  onClose, 
  prediction, 
  predictionType 
}: PredictionDetailsCardProps) => {
  
  // Obter informações do animal baseado na predição
  const animalInfo = getAnimalInfo(prediction, predictionType);

  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="p-0 overflow-hidden max-w-[95vw] w-[700px] max-h-[90vh]">
        <div className="relative h-full flex flex-col">
          <DialogHeader className="p-6 border-b">
            <DialogTitle className="text-2xl font-bold">
              {predictionType.charAt(0).toUpperCase() + predictionType.slice(1)}: {prediction}
            </DialogTitle>
          </DialogHeader>
          
          <Button 
            variant="ghost" 
            size="icon" 
            className="absolute top-4 right-4" 
            onClick={onClose}
          >
            <X size={18} />
          </Button>
          
          <div className="flex-1 overflow-auto p-6 flex flex-col md:flex-row gap-6">
            <div className="w-full md:w-1/2 flex flex-col justify-center">
              <div className="text-center mb-6">
                <h3 className="prediction-number mb-2">{prediction}</h3>
                <p className="text-lg text-muted-foreground capitalize">{predictionType}</p>
              </div>
              
              {(predictionType === "milhar" || predictionType === "centena" || predictionType === "grupo") && (
                <div className="bg-muted/30 rounded-xl p-4 text-center">
                  <h4 className="text-lg font-medium mb-2">Grupo: {getGroupFromNumber(prediction) || prediction}</h4>
                  <p className="text-xl font-bold mb-1">{animalInfo.name}</p>
                  <p className="text-sm text-muted-foreground">Jogo do Bicho</p>
                </div>
              )}
              
              <div className="mt-6">
                <h4 className="font-medium mb-2">Informações adicionais:</h4>
                <ul className="space-y-2 text-sm">
                  <li><strong>Ocorrências recentes:</strong> 3 vezes nos últimos 30 sorteios</li>
                  <li><strong>Última vez sorteado:</strong> 12/04/2025</li>
                  <li><strong>Posição no ranking:</strong> #42 entre os mais sorteados</li>
                </ul>
              </div>
            </div>
            
            <div className="w-full md:w-1/2 flex items-center justify-center">
              <div className="w-36 h-36 rounded-full bg-yellow-300 border-4 border-black flex items-center justify-center shadow-lg">
                <span className="prediction-number text-black">{animalInfo.firstLetter}</span>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PredictionDetailsCard;
